import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_CABIN: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Кабина хранится в&nbsp;удобном кейсе на&nbsp;колёсах, который выкатывается на&nbsp;локацию незадолго до&nbsp;мероприятия',
            alt: 'Хранение кабины в кейсе',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/wheeled-case-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/wheeled-case.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/wheeled-case-drawing.webp',
            image_webp: '/assets/images/ui/how-it-work/webp/wheeled-case.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Сборка из&nbsp;отдельных легких панелей занимает менее 10&nbsp;минут одним человеком',
            alt: 'Сборка панелей',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/fast-assembly-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/fast-assembly.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/fast-assembly-drawing.webp',
            image_webp: '/assets/images/ui/how-it-work/webp/fast-assembly.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. Переводчики работают всё мероприятие в&nbsp;комфортных и&nbsp;профессиональных условиях кабины по&nbsp;международным стандартам ISO4043',
            alt: 'Комфорт кабины',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/audio-to-interpreters-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/audio-to-interpreters.webp',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'А как в работе',
        description:
            'Процесс реальной сборки кабины и&nbsp;работы в&nbsp;ней переводчиков, демонтаж',
        width: 248,
        height: 139,
        duration: '0:40',
        link: 'https://rutube.ru/video/private/6f3987316966ede981f3794f1724f930/?p=Rh8pdGzuXVTsNdeOFM2EYQ/',
        video_preview:
            '/assets/images/usage/cabin/jpg-png/assembly-process.jpg',
        video_preview_webp:
            '/assets/images/usage/cabin/webp/assembly-process.webp',
    },
}

export default HOW_IT_WORK_CABIN
